import React from 'react';
import classNames from 'classnames';
import AppBreadcrumb from './AppBreadcrumb';
import { CLUBS } from './utilities/constants';
import './components/Topbar/AppTopbar.css';

const AppTopbar = props => {
  const profileItemClassName = classNames('profile-item', {
    'active-menuitem fadeInDown': props.topbarUserMenuActive,
  });

  const currentClub = CLUBS.find(
    club => club.id === Number(props.userClub)
  );

  const isNhlUser = currentClub?.id === 1;

  return (
    <div className="layout-topbar modern-app-topbar">
      <div className="topbar-left modern-app-topbar__left">
        <button
          type="button"
          className="menu-button p-link modern-app-topbar__back"
          onClick={props.onMenuButtonClick}
          title="Toggle navigation"
          aria-label="Toggle navigation"
        >
          <i className="pi pi-chevron-left"></i>
        </button>

        <span className="topbar-separator"></span>

        <div
          className="layout-breadcrumb viewname modern-app-topbar__breadcrumb"
          style={{ textTransform: 'uppercase' }}
        >
          {/* <AppBreadcrumb routers={props.routers} /> */}
        </div>

        <img
          id="logo-mobile"
          className="mobile-logo"
          src="assets/layout/images/logo-supponor-168x170.png"
          alt="Supponor Hub"
        />
      </div>

      <div className="topbar-right modern-app-topbar__right">
        <ul className="topbar-menu">
          {/* Notifications are intentionally hidden for now.
              The existing notification handlers/state remain in App.js,
              so the bell can be restored later without reworking the layout. */}

          <li className={profileItemClassName}>
            <button
              type="button"
              className="p-link modern-app-topbar__profile"
              onClick={props.onTopbarUserMenu}
              title="Open user menu"
              aria-label="Open user menu"
            >
              <span
                className={[
                  'modern-app-topbar__avatar',
                  isNhlUser ? 'modern-app-topbar__avatar--nhl' : '',
                ]
                  .filter(Boolean)
                  .join(' ')}
              >
                {currentClub ? (
                  <img
                    className="modern-app-topbar__avatar-logo"
                    src={`assets/clubs/${currentClub.code}.svg`}
                    alt=""
                    aria-hidden="true"
                  />
                ) : (
                  <i className="pi pi-user"></i>
                )}
              </span>

              {currentClub && (
                <span
                  className={[
                    'modern-app-topbar__club',
                    isNhlUser
                      ? 'modern-app-topbar__club--nhl'
                      : '',
                  ]
                    .filter(Boolean)
                    .join(' ')}
                  title={currentClub.name}
                >
                  {currentClub.code}
                </span>
              )}

              <span className="profile-name modern-app-topbar__email">
                {props.userEmail}
              </span>

              <i className="pi pi-chevron-down modern-app-topbar__chevron"></i>
            </button>

            <ul className="profile-menu fade-in-up modern-app-topbar__profile-menu">
              {currentClub && (
                <li className="modern-app-topbar__profile-context">
                  <div className="modern-app-topbar__profile-context-inner">
                    <span
                      className={[
                        'modern-app-topbar__club',
                        'modern-app-topbar__club--menu',
                        isNhlUser
                          ? 'modern-app-topbar__club--nhl'
                          : '',
                      ]
                        .filter(Boolean)
                        .join(' ')}
                    >
                      {currentClub.code}
                    </span>

                    <span className="modern-app-topbar__profile-context-text">
                      <small>Representing</small>
                      <strong>{currentClub.name}</strong>
                    </span>
                  </div>
                </li>
              )}

              {/* Profile and Settings are intentionally hidden for now.
                  The routes remain untouched and can be restored here later. */}

              <li className="modern-app-topbar__logout">
                <a>
                  <button
                    type="button"
                    className="p-link"
                    onClick={props.onLogout}
                  >
                    <i className="pi pi-power-off"></i>
                    <span>Logout</span>
                  </button>
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default AppTopbar;
